/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

// $FlowExpectedError
import React, {useState} from 'react';
import {trackCustomEvent} from 'gatsby-plugin-google-analytics';
import {sharedStyles} from 'theme';

const FeedbackForm = ({pagrUrl}) => {
  const [feedbackGiven, setFeedbackGiven] = useState(null);
  if (feedbackGiven === true) {
    return 'شكرا لك!';
  } else if(feedbackGiven === false){
    return (
      <div
            dangerouslySetInnerHTML={{__html: `
            <script>
            !function(){function d(a,b){for(var c=0;c<a.length&&!b.call(this,a[c]);c++);}function h(a){d(document.querySelectorAll("iframe.airtable-embed.airtable-dynamic-height"),a)}function e(a){var b=a.getBoundingClientRect();a.contentWindow.postMessage({key:"airtableEmbedViewportChanged",embedRectInViewport:{top:b.top,right:b.right,bottom:b.bottom,left:b.left},embedViewportSize:{height:window.innerHeight,width:window.innerWidth}},"*")}function k(){d(document.querySelectorAll("iframe.airtable-embed"),e)}function f(){clearTimeout(g);
              g=setTimeout(k,200)}if(!window._didAddAirtableGlobalEmbedListeners){window._didAddAirtableGlobalEmbedListeners=!0;var g;window.addEventListener("resize",f,!1);window.addEventListener("scroll",f,!1);window.addEventListener("message",function(a){var b=a.data;b&&"airtableEmbedContentDidResize"===b.key&&h(function(c){if(a.source===c.contentWindow)return c._airtableDidDisableScrollbar||(c._airtableDidDisableScrollbar=!0,c.contentWindow.postMessage({key:"airtableDisableScrollbar"},"*"),e(c)),c.height=b.height,
              !0})},!1)}}();
            </script><iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shr8IrkbtpHf0cPg2?backgroundColor=blue&prefill_url=${pagrUrl}" frameborder="0" onmousewheel="" width="100%" height="633" style="background: transparent; border: 1px solid #ccc;"></iframe>
            `}}
          />)
  } else if(feedbackGiven === null || feedbackGiven === false ){
    return (
      <div style={{
        "border-bottom": ".1rem solid rgba(14,30,37,.054)",
        "border-top": ".1rem solid rgba(14,30,37,.054)",
        "margin-top": "1.5rem",
        padding: "1.5rem 0",
        position: "relative",
        display: "block"
        }}>
          <div style={{display: "flex"}}>
        <div style={{"align-self": "center"}}>
          <h3 class="media__title">
            هل اعجبك محتوى الصفحة؟
          </h3>
          <p class="media__copy">
          تساعدنا ملاحظاتك على تحسين محتوانا.
          </p>
        </div>
        <div>
          <button
            css={[sharedStyles.articleLayout.feedbackButton, {marginLeft: '6px', transform: "translateX(-27px)"}]}
            aria-label="Yes"
            onClick={e => {
              e.preventDefault();
              trackCustomEvent({
                category: 'Feedback Button',
                action: 'feedback',
                label: window.location.pathname,
                value: 1,
              });
              setFeedbackGiven(true);
            }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" aria-hidden="true"><g fill="none" fill-rule="evenodd"><circle cx="32" cy="32" r="32" fill="#E0F6EC" fill-rule="nonzero"></circle> <g stroke="#0F7B72" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M40 29h-7.645l1.473-3.889c.377-.996.042-2.135-.803-2.73-.963-.679-2.263-.427-2.936.569L26 29v9a4 4 0 0 0 4 4h6.517c1.51 0 2.893-.852 3.573-2.203L42 36v-5a2 2 0 0 0-2-2zM22 29v12"></path></g></g></svg>
          </button>
          <button
            css={[sharedStyles.articleLayout.feedbackButton, {marginLeft: '3px', transform: "translateX(-27px)"}]}
            aria-label="No"
            onClick={e => {
              e.preventDefault();
              trackCustomEvent({
                category: 'Feedback Button',
                action: 'feedback',
                label: window.location.pathname,
                value: 0,
              });
              console.warn('setting feedback to false');
              setFeedbackGiven(false);
            }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" aria-hidden="true"><g fill="none" fill-rule="evenodd"><circle cx="32" cy="32" r="32" fill="#F9CECC" fill-rule="nonzero"></circle> <g stroke="#812F2B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M23 35h7.645l-1.473 3.889c-.377.996-.042 2.135.803 2.73.963.679 2.263.427 2.936-.569l4.09-6.05v-9a4 4 0 0 0-4-4h-6.518c-1.51 0-2.893.852-3.573 2.202L21 28v5a2 2 0 0 0 2 2zM41 35V23"></path></g></g></svg>
          </button>
        </div>
        </div>
      </div>
    );
  } 
};

export default FeedbackForm;
